import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { alarmsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

export const getAlarmProfilesAPI = async (
  namespace: string,
  sourceId: string,
  signal?: AbortSignal,
) => {
  const url = alarmsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();
  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/sources/${sourceId}/alarm_profiles`,
      {
        headers,
        signal: signal,
      },
    );
    return response;
  } catch (err) {
    if (signal?.aborted) return;
    else if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch alarm profiles. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching alarm profiles.",
    );
  }
};
